import { SERVICE_STATUSES } from '@common/constants';
import { PRODUCT_IDS } from '@adsk/alloy-provider';

export const TEMPLATE_PROJECT_TYPE = 'Template Project';

export const TEMPLATE_PROJECT_CLASSIFICATION = 'template';

export const ACS_UNIFIED_SOURCE = 'acsUnified';

export const ACTIVE_SERVICES = [
  SERVICE_STATUSES.ACTIVE,
  SERVICE_STATUSES.ACTIVATING,
];

export const mockedFetchDataResults = {
  accounts: [
    {
      accessLevels: {
        acsProjectAdmin: true,
        accountAdmin: true,
        projectAdmin: true,
      },
      createProjectAccessLevels: ['accountAdmin'],
      hasAcsUnifiedProjects: true,
      id: '1',
      isAccEligible: true,
      name: 'Account A',
    },
    {
      accessLevels: {
        acsProjectAdmin: true,
        accountAdmin: true,
        projectAdmin: false,
      },
      createProjectAccessLevels: ['accountAdmin'],
      hasAcsUnifiedProjects: true,
      id: '2',
      isAccEligible: true,
      name: 'Account B',
    },
    {
      accessLevels: {
        acsProjectAdmin: true,
        accountAdmin: false,
        projectAdmin: true,
      },
      createProjectAccessLevels: ['accountAdmin'],
      hasAcsUnifiedProjects: true,
      id: '3',
      isAccEligible: true,
      name: 'Account C',
    },
    {
      accessLevels: {
        acsProjectAdmin: true,
        accountAdmin: false,
        projectAdmin: false,
      },
      createProjectAccessLevels: ['accountAdmin'],
      hasAcsUnifiedProjects: true,
      id: '4',
      isAccEligible: true,
      name: 'Account D',
    },
    {
      accessLevels: {
        acsProjectAdmin: true,
        accountAdmin: true,
        projectAdmin: true,
      },
      createProjectAccessLevels: ['accountAdmin', 'projectAdmin'],
      hasAcsUnifiedProjects: true,
      id: '5',
      isAccEligible: true,
      name: 'Account E',
    },
    {
      accessLevels: {
        acsProjectAdmin: true,
        accountAdmin: true,
        projectAdmin: false,
      },
      createProjectAccessLevels: ['accountAdmin', 'projectAdmin'],
      hasAcsUnifiedProjects: true,
      id: '6',
      isAccEligible: true,
      name: 'Account F',
    },
    {
      accessLevels: {
        acsProjectAdmin: true,
        accountAdmin: false,
        projectAdmin: true,
      },
      createProjectAccessLevels: ['accountAdmin', 'projectAdmin'],
      hasAcsUnifiedProjects: true,
      id: '7',
      isAccEligible: true,
      name: 'Account G',
    },
    {
      accessLevels: {
        acsProjectAdmin: true,
        accountAdmin: false,
        projectAdmin: false,
      },
      createProjectAccessLevels: ['accountAdmin', 'projectAdmin'],
      hasAcsUnifiedProjects: true,
      id: '8',
      isAccEligible: true,
      name: 'Account H',
    },
  ],
  projectTypes: [
    {
      category: 'Category 1',
      displayName: 'Project Type 1',
      value: 'Project Type 1',
    },
  ],
  templates: [
    {
      id: '1',
      name: 'Template 1',
    },
    {
      id: '2',
      name: 'Template 2',
    },
  ],
};

export const mockedFilteredAccounts = [
  {
    accessLevels: {
      acsProjectAdmin: true,
      accountAdmin: true,
      projectAdmin: true,
    },
    createProjectAccessLevels: ['accountAdmin'],
    hasAcsUnifiedProjects: true,
    id: '1',
    isAccEligible: true,
    name: 'Account A',
  },
  {
    accessLevels: {
      acsProjectAdmin: true,
      accountAdmin: true,
      projectAdmin: false,
    },
    createProjectAccessLevels: ['accountAdmin'],
    hasAcsUnifiedProjects: true,
    id: '2',
    isAccEligible: true,
    name: 'Account B',
  },
  {
    accessLevels: {
      acsProjectAdmin: true,
      accountAdmin: true,
      projectAdmin: true,
    },
    createProjectAccessLevels: ['accountAdmin', 'projectAdmin'],
    hasAcsUnifiedProjects: true,
    id: '5',
    isAccEligible: true,
    name: 'Account E',
  },
  {
    accessLevels: {
      acsProjectAdmin: true,
      accountAdmin: true,
      projectAdmin: false,
    },
    createProjectAccessLevels: ['accountAdmin', 'projectAdmin'],
    hasAcsUnifiedProjects: true,
    id: '6',
    isAccEligible: true,
    name: 'Account F',
  },
  {
    accessLevels: {
      acsProjectAdmin: true,
      accountAdmin: false,
      projectAdmin: true,
    },
    createProjectAccessLevels: ['accountAdmin', 'projectAdmin'],
    hasAcsUnifiedProjects: true,
    id: '7',
    isAccEligible: true,
    name: 'Account G',
  },
];

export const PROJECT_PRODUCT_MOCK = [
  { status: SERVICE_STATUSES.ACTIVE, key: PRODUCT_IDS.DOCS },
  { status: SERVICE_STATUSES.ACTIVE, key: PRODUCT_IDS.COST },
  { status: SERVICE_STATUSES.ACTIVE, key: PRODUCT_IDS.BUILD },
  { status: SERVICE_STATUSES.ACTIVE, key: PRODUCT_IDS.INSIGHT },
  { status: SERVICE_STATUSES.ACTIVE, key: PRODUCT_IDS.PROJECT_ADMINISTRATION },
  { status: SERVICE_STATUSES.ACTIVE, key: PRODUCT_IDS.MODEL_COORDINATION },
  { status: SERVICE_STATUSES.ACTIVE, key: PRODUCT_IDS.DESIGN_COLLABORATION },
  { status: SERVICE_STATUSES.ACTIVE, key: PRODUCT_IDS.TAKEOFF },
  { status: SERVICE_STATUSES.ACTIVE, key: PRODUCT_IDS.AUTOSPECS },
];
